import { useEffect, useState } from "react";
import { Alert, Collapse } from "@mui/material";
import { useTranslation } from "react-i18next";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import { useChild } from "../../context/ChildContext";

const DDropsBanner = () => {
  const { currentChild, showDropBanner } = useChild();
  const { t } = useTranslation();
  const [needsDDrops, setNeedsDDrops] = useState(false);

  useEffect(() => {
    if (!currentChild) return;

    const todayDate = new Date().toISOString().split("T")[0];
    const todayStart = `${todayDate}T00:00:00`;
    const shouldShow = showDropBanner();

    let hasDDropsFromFeeding = false;
    let hasDDropsFromMedicine = false;

    const updateBanner = () => {
      const afterTwoPM = new Date().getHours() >= 14;
      setNeedsDDrops(shouldShow && afterTwoPM && !hasDDropsFromFeeding && !hasDDropsFromMedicine);
    };

    const unsubFeedings = onSnapshot(
      query(
        collection(db, `children/${currentChild.id}/feedings`),
        where("start", ">=", todayStart)
      ),
      (snapshot) => {
        hasDDropsFromFeeding = snapshot.docs.some((doc) => doc.data().dVitamin === true);
        updateBanner();
      }
    );

    const unsubMedicines = onSnapshot(
      query(
        collection(db, `children/${currentChild.id}/medicines`),
        where("start", ">=", todayStart)
      ),
      (snapshot) => {
        hasDDropsFromMedicine = snapshot.docs.some((doc) =>
          (doc.data().medicines || []).includes("D-dråber")
        );
        updateBanner();
      }
    );

    return () => {
      unsubFeedings();
      unsubMedicines();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentChild]);

  if (!needsDDrops) return null;

  return (
    <Collapse in={needsDDrops}>
      <Alert
        variant="filled"
        severity="error"
        icon={false}
        sx={{
          borderRadius: 0,
          bgcolor: "#f1828d",
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {t("ddrops.reminder")}
      </Alert>
    </Collapse>
  );
};

export default DDropsBanner;
